import React, { useEffect, useState } from "react";
import { Layout, Row, Col, Pagination } from "antd";
import CommonReportTable from "utils/table/CommonReportTable";
import InventoryTabs from "../InventoryTabs";
import { ICustomError } from "models/interfaces/ICustomError";
import { AppSetting } from "utils/appSettings";
import { LoggerService } from "sharedServices";
import CustomError from "controls/CustomError/CustomError";
import { IUnfilledZonesResponse } from "models/interfaces";
import { unfilledZonesHeaders } from "./unfilledZonesUtils";
import { formatThousandSeparator } from "utils/commonFunction";
import { HouseKeepingService } from "services/StubHubServices/houseKeepingServices/houseKeepingService.service";

const { Content } = Layout;
const DEFAULT_PAGE_INDEX = AppSetting.DEFAULT_PAGE_INDEX;
const PAGE_SIZE = AppSetting.PAGE_SIZE;

const UnfilledZonesTable: React.FC<{
  path: string;
  searchQuery: string | null;
}> = ({ path, searchQuery }) => {
  const [queryParams, setQueryParams] = useState<any>(null);
  const [unfilledZonesData, setSoldInventoryData] =
    useState<IUnfilledZonesResponse | null>(null);
  const [showLoader, setShowLoader] = useState(false);
  const [dataFetchError, setDataFetchError] = useState<ICustomError | null>(
    null
  );

  const [defaultQueryParams] = useState<any>({
    clientZone: AppSetting.TIMEZONE,
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: PAGE_SIZE,
    sortColumn: "pl_date",
    sortOrder: "desc",
  });

  const getSoldInventoryData = async (query: any) => {
    try {
      setShowLoader(true);
      const response = await new HouseKeepingService().getUnfilledZonesList({
        ...query,
      });

      setSoldInventoryData(response.data.data);
      setShowLoader(false);
    } catch (error: any) {
      setShowLoader(false);
      await new LoggerService().log({
        payload: error,
        function_name: "getActiveInventoryData",
      });

      setDataFetchError({ ...error, refreshAction: getSoldInventoryData });
    }
  };

  useEffect(() => {
    queryParams && getSoldInventoryData(queryParams);
  }, [queryParams]);

  useEffect(() => {
    if (defaultQueryParams) {
      setQueryParams({
        ...defaultQueryParams,
        ...queryParams,
        pageIndex: DEFAULT_PAGE_INDEX,
      });
    }
  }, [defaultQueryParams]);

  useEffect(() => {
    if (searchQuery !== null) {
      setQueryParams({
        ...queryParams,
        pageIndex: DEFAULT_PAGE_INDEX,
        searchText: searchQuery,
      });
    }
  }, [searchQuery]);

  const getViewTable = () => {
    if (unfilledZonesData && unfilledZonesData?.total >= 0) {
      return (
        <h4>
          {unfilledZonesData?.total === 1
            ? formatThousandSeparator(unfilledZonesData?.total) + " Record Found"
            : formatThousandSeparator(unfilledZonesData?.total) + " Records Found"}
        </h4>
      );
    }
    return "";
  }

  return dataFetchError ? (
    <CustomError {...dataFetchError} />
  ) : (
    <Content className="mainContainer relative">
      <div className="cancelledShowsPagination">
        <Row className="flx justifyContentBetween alignItemsCenter">
          <Col span={24}>
            <ul className="innerHeaderRight">
              <li>
                { getViewTable() }
                {/* <h4>{unfilledZonesData?.total} Records Found</h4> */}
              </li>
              <li>
                <Pagination
                  className="pagination"
                  hideOnSinglePage={true}
                  defaultCurrent={1}
                  current={queryParams?.pageIndex}
                  total={unfilledZonesData?.total}
                  pageSize={PAGE_SIZE}
                  onChange={(pageNumber) =>
                    setQueryParams({
                      ...queryParams,
                      pageIndex: pageNumber,
                    })
                  }
                  showSizeChanger={false}
                />
              </li>
            </ul>
          </Col>
        </Row>
      </div>
      <div className="tabContainer removeTblLRSpc">
        <InventoryTabs path={path} />
        <div className="">
          <CommonReportTable
            // tableClass="customTbl scroll-x-y fixedHeaderFooter"
            tableHeight={{ maxHeight: "calc(100vh - 218px)" }}
            onSort={(sortIndex: string, sortOrder: "asc" | "desc") => {
              setQueryParams({
                ...queryParams,
                sortColumn: sortIndex,
                sortOrder: sortOrder,
              });
            }}
            sortField={{
              dataIndex: queryParams?.sortColumn,
              order: queryParams?.sortOrder,
            }}
            data={unfilledZonesData?.data ?? []}
            headers={unfilledZonesHeaders}
            loading={showLoader}
            enableRowSelect={false}
          />
        </div>
      </div>
    </Content>
  );
};

export default UnfilledZonesTable;
